import { getDateGivenOffset, getFormattedAPIDate } from '@/utilities/dates'

class BasePlotTypeApiParms {
  constructor(tab) {
    this.tab = tab
    this.selections = tab.selection.map(item => {
      return {
        id: item.id,
        summaryFilters: item.selection,
        detailFilters: item.selectedItems,
      }
    })
  }

  getFieldGivenId(id) {
    const [first] = this.selections.filter(item => item.id === id)
    return first || null
  }

  getFirstDetailFilter(id, prop) {
    const field = this.getFieldGivenId(id)
    if (field.detailFilters) {
      const filters = field.detailFilters
      try {
        return filters.length > 0 ? filters[0][prop] : null
      } catch {
        return null
      }
    }
    return null
  }

  getSummaryFilter(id) {
    const field = this.getFieldGivenId(id)
    const filters = field.summaryFilters
    return filters
  }

  getArrayDetailFiltersGivenProp(id, prop) {
    const field = this.getFieldGivenId(id)
    const filters = field.detailFilters
    const items = filters.map(item => item[prop])
    return items
  }

  getArrayDetailFilters(id) {
    const field = this.getFieldGivenId(id)
    const filters = field.detailFilters
    return filters !== undefined ? filters : []
  }

  getStartDateSummaryFilter(id) {
    const filters = this.getSummaryFilter(id)
    return filters !== undefined ? filters.dates.startDate : {}
  }

  getEndDateSummaryFilter(id) {
    const filters = this.getSummaryFilter(id)
    return filters !== undefined ? filters.dates.endDate : {}
  }

  getDateValueSummaryFilter(id) {
    const filters = this.getSummaryFilter(id)
    return filters !== undefined ? filters.dates.value : {}
  }
}

export class AnalyticTrendsRiskScore extends BasePlotTypeApiParms {
  getSelector() {
    const dateValue = this.getDateValueSummaryFilter('dates')
    const startDate = getFormattedAPIDate(
      this.getStartDateSummaryFilter('dates'),
    )
    const endDate = getFormattedAPIDate(this.getEndDateSummaryFilter('dates'))

    return {
      tailName: this.getFirstDetailFilter('tail', 'text'),
      featureId: this.getFirstDetailFilter('amcFeature', 'value'),
      featureName: this.getFirstDetailFilter('amcFeature', 'text'),
      startDate: dateValue !== '0' ? startDate : null,
      endDate: dateValue !== '0' ? endDate : null,
      isRiskScore: this.getFirstDetailFilter('amcFeature', 'isRiskScore'),
    }
  }
}

export class FlightParameterTrends extends BasePlotTypeApiParms {
  getSelector() {
    return {
      airline: this.getFirstDetailFilter('tail', 'airlineId'),
      masterModel: this.getFirstDetailFilter('tail', 'masterModelId'),
      aircraft: this.getFirstDetailFilter('tail', 'text'),
      system: this.getFirstDetailFilter('system', 'value'),
      component: this.getFirstDetailFilter('component', 'value'),
      componentName: this.getFirstDetailFilter('component', 'text'),
      parameter: this.getFirstDetailFilter('parameter', 'value'),
      paramName: this.getFirstDetailFilter('parameter', 'text'),
      flightNum: this.getFirstDetailFilter('flight', 'value'),
      flightPhase: this.getFirstDetailFilter('flightPhase', 'value'),
      deptDate: this.getSummaryFilter('chartDate'),
      id: this.tab.id,
      save: false,
      hidden: this.tab.hidden,
      loading: false,
      noData: false,
      isCustomParameter:
        this.getFirstDetailFilter('component', 'value') === 'custom_parameter'
          ? true
          : false,
    }
  }
}

export class AnalyticComparisonRiskScore extends BasePlotTypeApiParms {
  getDateGivenDaysBack(daysBack) {
    const date = getDateGivenOffset(new Date(), -Math.abs(daysBack))
    const apiDate = getFormattedAPIDate(date)
    return apiDate
  }

  getSelector() {
    const startDate = getFormattedAPIDate(
      this.getStartDateSummaryFilter('dates'),
    )
    const endDate = getFormattedAPIDate(this.getEndDateSummaryFilter('dates'))
    const analyticAirlineIds = this.getFirstDetailFilter(
      'amcAnalyticModule',
      'airlineIds',
    )
    const tailAirlineIds = Array.from(
      new Set(this.getArrayDetailFiltersGivenProp('tail', 'airlineId')),
    )
    const supportedAirlineIds =
      tailAirlineIds.length > 0 ? tailAirlineIds : analyticAirlineIds

    return {
      airlineIds: supportedAirlineIds,
      featureIds: this.getArrayDetailFiltersGivenProp(
        'amcFeature',
        'featureId',
      ),
      features: this.getArrayDetailFilters('amcFeature'),
      startDate,
      endDate,
      tails: this.getArrayDetailFiltersGivenProp('tail', 'text'),
    }
  }
}

export class FlightParameterComparison extends BasePlotTypeApiParms {
  getSelector() {
    const startDate = getFormattedAPIDate(
      this.getStartDateSummaryFilter('dates'),
    )
    const endDate = getFormattedAPIDate(this.getEndDateSummaryFilter('dates'))
    const tailAirlineIds = Array.from(
      new Set(this.getArrayDetailFiltersGivenProp('tail', 'airlineId')),
    )

    return {
      id: this.tab.id,
      startDate,
      endDate,
      masterModel: this.getFirstDetailFilter('masterModel', 'value'),
      component: this.getFirstDetailFilter('component', 'value'),
      parameter: this.getFirstDetailFilter('parameter', 'value'),
      flightPhase: this.getFirstDetailFilter('flightPhase', 'value'),
      tails: this.getArrayDetailFiltersGivenProp('tail', 'text'),
      airlineIds: tailAirlineIds,
    }
  }
}

export class ConditionMonitoringReportDataTrends extends BasePlotTypeApiParms {
  getSelector() {
    const startDate = this.getStartDateSummaryFilter('dates')
    const endDate = this.getEndDateSummaryFilter('dates')

    return {
      id: this.tab.id,
      startDate,
      endDate,
      tailNumber: this.getFirstDetailFilter('acmfTail', 'text'),
      parameterId: this.getFirstDetailFilter('acmfParameterName', 'value'),
      isSeriesData: false,
      reportNumber: this.getFirstDetailFilter('acmfReportType', 'value'),
    }
  }
}
